module.exports = function ($state, $timeout, $location, specialsGroupsService, breakpointsService, hyphenate, $anchorScroll, moveFocus) {
    return {
        restrict: 'E',
        scope: true,
        link(scope, element) {

            function isScrolledIntoView($el) {
                const el = $el[0];
                const elemTop = el.getBoundingClientRect().top;
                const elemBottom = el.getBoundingClientRect().bottom;
                const isVisible = (elemTop >= 0) && (elemBottom <= window.innerHeight);
                return isVisible;
            }


            //To scroll to the selected patshop in small format.
            const scrollToSelectedGroup = function () {
                if (scope.specialsGroupsService.selectedGroup && $state.includes('shop.specials.groupsv2')) {
                    if (breakpointsService.isSmallFormat()) {
                        $timeout(function () {
                            const selectedGroupId = `specials-group-${hyphenate(scope.specialsGroupsService.selectedGroup.Name)}`;
                            $location.hash(selectedGroupId);
                            $anchorScroll();
                        });
                    }
                }
            };
            const scroller = element.find('.hideScroll-wrapper');
            scroller.on('scrollstop', function () {
                if (scope.openGroup) {
                    scope.showClone = !isScrolledIntoView(element.find('.specialsGroups-link:not(.is-closed)'));
                    scope.$apply();
                }
            });
//
//            scope.cloneClick = function () {
//                const openLink = element.find('.specialsGroups-specialGroup:not(.is-clone) .specialsGroups-link');
//            };

            scope.isSmallFormat = function () {
                return breakpointsService.isSmallFormat();
            };

            scope.specialsGroupsService = specialsGroupsService;

            scope.selectSpecialsGroup = function (specialsGroup) {
                if (!breakpointsService.isSmallFormat()) {
                    moveFocus('#center-panel');
                }

                scope.specialsGroupsService.selectedGroup = specialsGroup;
            };

            scope.isActive = function (groupName) {
                return $state.params.specialGroup === hyphenate(groupName);
            };

            function update() {
                specialsGroupsService.listGroups().then(function (groups) {
                    scope.specialsGroups = groups;
                    scrollToSelectedGroup();
                });
            }

            function init() {
                specialsGroupsService.invalidateSpecialGroups();
                update();
            }

            function updateHandler() {
                update();
                $state.forceReload();
            }

            scope.$watch(function () {
                return $state.params.specialGroup;
            }, function (specialGroupName) {
                specialsGroupsService.selectGroupByName(specialGroupName);
            });

            scope.$on('address-update', updateHandler);
            scope.$on('login:success', function () {
                specialsGroupsService.invalidateSpecialGroups();
                updateHandler();
            });

            init();
        },
        template: require('./specials-groups-template-v2.html').trim()
    };
};


/** WEBPACK FOOTER **
 ** ./wowapp/src/shop/components/specials/specials-groups-directive-v2.js
 **/